/**
 * ru-phonetics-ui.js — экран /foneticheskij-razbor: слово → ударение из базы
 * сайта (/api/ru-word) → RuPhonetics.analyze → транскрипция, слоги, таблица
 * «буква — звук», цветная схема для 1–4 класса, правила за непростыми звуками.
 *
 * Ударение — от базы ударений (те же слои, что у голосов сайта). У омографа
 * человек выбирает чтение; слово, которого база не знает, человек размечает
 * сам нажатием на ударную гласную — разбор без ударения не делается.
 * Тексты и адрес API — window.__FON = {T, wordUrl, slug}.
 */
(function () {
    'use strict';

    var CFG = window.__FON || {};
    var T = CFG.T || {};
    var P = window.RuPhonetics;
    var form = document.getElementById('fonForm');
    var input = document.getElementById('fonWord');
    var out = document.getElementById('fonOut');
    if (!P || !form || !input || !out) return;

    var SLUG = CFG.slug || 'foneticheskij-razbor';
    var ACUTE = '́';
    var VOWELS = 'аеёиоуыэюя';
    var grade = 'senior';
    try { if (window.__toolSettings) grade = window.__toolSettings.load(SLUG, 'grade', 'senior') || 'senior'; } catch (_) {}

    function tr(key, vars) {
        var s = T[key] || key;
        if (vars) for (var k in vars) if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split(':' + k).join(vars[k]);
        return s;
    }
    function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
    }
    // 1 буква, 2 буквы, 5 букв — формы из перевода: 'буква|буквы|букв'
    function plural(n, formsKey) {
        var f = String(T[formsKey] || '').split('|');
        if (f.length !== 3) return String(n);
        var m10 = n % 10, m100 = n % 100;
        var w = (m10 === 1 && m100 !== 11) ? f[0] : (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) ? f[1] : f[2];
        return n + ' ' + w;
    }
    function stage(name, data) {
        try { if (window.__stage) window.__stage(name); } catch (_) {}
        try { if (window.__aeFunnel) window.__aeFunnel(name, data || {}); } catch (_) {}
    }

    var current = null;          // {form, source, morph}

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        run(input.value);
    });

    function clean(w) { return String(w || '').trim().toLowerCase().replace(/[^а-яё́+-]/g, ''); }

    function run(raw) {
        var w = clean(raw);
        out.innerHTML = '';
        if (!w || !/[а-яё]/.test(w)) { out.appendChild(el('p', 'fon-msg', tr('enter_word'))); return; }
        // слово без гласных («в», «к», «брр»): ударения нет, разбор строит сам движок
        if (!/[аеёиоуыэюя]/.test(w)) { show({ form: w.replace(/[́+]/g, ''), source: 'none', morph: [] }); return; }
        // слово, размеченное человеком (акут или «+»), в базу не идёт
        if (/[́+]/.test(w)) { show({ form: w.replace(/\+([аеёиоуыэюя])/g, '$1' + ACUTE), source: 'manual', morph: [] }); return; }
        // без словаря ударение ясно, когда в слове «ё» или одна гласная
        var nv = (w.match(/[аеёиоуыэюя]/g) || []).length;
        var obvious = w.indexOf('ё') >= 0 ? 'yo' : (nv === 1 ? 'one' : null);
        if (obvious && !CFG.wordUrl) { show({ form: w, source: obvious, morph: [] }); return; }
        out.appendChild(el('p', 'fon-msg', tr('loading')));
        stage('lookup');
        if (!CFG.wordUrl || !window.RuWord) { manual(w, tr('no_service')); return; }
        window.RuWord.get(w, { url: CFG.wordUrl })
            .then(function (data) {
                var reads = (data && data.readings) || [];
                if (!reads.length) { if (obvious) show({ form: w, source: obvious, morph: data.morph || [] }); else manual(w, tr('no_stress')); return; }
                if (reads.length > 1) { choose(w, reads, data.morph || []); return; }
                show({ form: reads[0].form, source: reads[0].source, morph: data.morph || [] });
            })
            .catch(function () { if (obvious) show({ form: w, source: obvious, morph: [] }); else manual(w, tr('no_service')); });
    }

    /** Омограф: человек выбирает чтение; разбор — сразу первого. */
    function choose(w, reads, morph) {
        out.innerHTML = '';
        var box = el('div', 'fon-choose');
        box.appendChild(el('p', 'fon-msg', tr('homograph')));
        var row = el('div', 'fon-chips');
        reads.forEach(function (r, i) {
            var b = el('button', 'fon-chip', r.form);
            b.type = 'button';
            b.addEventListener('click', function () { show({ form: r.form, source: r.source, morph: morph }, reads); });
            row.appendChild(b);
        });
        box.appendChild(row);
        out.appendChild(box);
        show({ form: reads[0].form, source: reads[0].source, morph: morph }, reads);
    }

    /** Слова нет в базе: человек сам нажимает ударную гласную. */
    function manual(w, why) {
        out.innerHTML = '';
        var box = el('div', 'fon-choose');
        box.appendChild(el('p', 'fon-msg', why));
        box.appendChild(el('p', 'fon-msg', tr('tap_stress')));
        var word = el('div', 'fon-word-pick');
        for (var i = 0; i < w.length; i++) {
            var ch = w[i];
            if (VOWELS.indexOf(ch) < 0) { word.appendChild(el('span', null, ch)); continue; }
            var b = el('button', 'fon-vbtn', ch);
            b.type = 'button';
            (function (idx) {
                b.addEventListener('click', function () {
                    show({ form: w.slice(0, idx + 1) + ACUTE + w.slice(idx + 1), source: 'manual', morph: [] });
                });
            })(i);
            word.appendChild(b);
        }
        box.appendChild(word);
        out.appendChild(box);
    }

    function show(sel, reads) {
        current = sel;
        var r = P.analyze(sel.form, { morph: sel.morph });
        var keep = out.querySelector('.fon-choose');
        out.innerHTML = '';
        if (reads && keep) out.appendChild(keep);
        if (!r) { out.appendChild(el('p', 'fon-msg', tr('no_stress'))); return; }
        var card = el('div', 'fon-result');

        // 1. слово, ударение, слоги
        var head = el('div', 'fon-head');
        var syl = el('p', 'fon-syl');
        r.syllables.forEach(function (s, i) {
            if (i) syl.appendChild(document.createTextNode('-'));
            var span = el('span', s.stressed ? 'fon-syl-s' : null, s.text);
            syl.appendChild(span);
        });
        if (!r.syllables.length) syl.appendChild(el('span', null, r.word));   // без гласных — слогов нет
        head.appendChild(syl);
        head.appendChild(el('p', 'fon-meta', plural(r.syllables.length, 'syllable_forms')
            + ' · ' + tr('source_' + (sel.source || 'dict'))));
        card.appendChild(head);

        // однобуквенный предлог или частица звучит слитно с соседним словом
        if (r.clitic) card.appendChild(el('p', 'fon-msg', tr('clitic_note')));

        // 2. транскрипция и допустимые записи (где учебники расходятся)
        card.appendChild(el('p', 'fon-tr', r.transcription));
        (r.variants || []).forEach(function (v) {
            card.appendChild(el('p', 'fon-variant', tr('variant', { tr: v.transcription }) + ' ' + tr('variant_' + v.note)));
        });

        // 3. цветная схема (1–4 класс)
        if (grade === 'junior') card.appendChild(scheme(r));

        // 4. таблица «буква — звук»
        card.appendChild(table(r));

        // 5. итог
        card.appendChild(el('p', 'fon-count', plural(r.letters, 'letter_forms') + ', ' + plural(r.soundsCount, 'sound_forms')));

        // 6. почему так
        var why = [];
        r.rows.forEach(function (row) {
            if (row.rule && T['rule_' + row.rule] && why.indexOf(row.rule) < 0) why.push(row.rule);
        });
        if (why.length) {
            var ul = el('ul', 'fon-why');
            why.forEach(function (rule) { ul.appendChild(el('li', null, tr('rule_' + rule))); });
            card.appendChild(el('h3', 'fon-h3', tr('why_title')));
            card.appendChild(ul);
        }

        // 7. копировать разбор в тетрадь
        var copy = el('button', 'fon-btn', tr('copy'));
        copy.type = 'button';
        copy.addEventListener('click', function () {
            var text = notebookText(r);
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(function () { if (window.__toast) window.__toast(tr('copied'), 'success'); }, function () {});
            }
        });
        card.appendChild(copy);
        out.appendChild(card);
        stage('analyzed', { source: sel.source, homograph: !!(reads && reads.length > 1) });
        try { if (window.__aeToolComplete) window.__aeToolComplete({ source: sel.source }); } catch (_) {}
    }

    // пара по звонкости и по твёрдости — как в образцах разбора: «глухой парный [б]»
    var VOICE_PAIR = { 'б': 'п', 'п': 'б', 'в': 'ф', 'ф': 'в', 'г': 'к', 'к': 'г', 'д': 'т', 'т': 'д', 'ж': 'ш', 'ш': 'ж', 'з': 'с', 'с': 'з' };
    var SOFT = '’';
    function describe(s) {
        if (s.kind === 'vowel') return tr(s.stressed ? 'vowel_stressed' : 'vowel_unstressed');
        var parts = [tr('consonant')];
        var v = tr(s.voiced ? 'voiced' : 'voiceless') + ' ' + tr(s.voicedPaired ? 'paired' : 'unpaired');
        if (s.voicedPaired && VOICE_PAIR[s.ch]) v += ' [' + VOICE_PAIR[s.ch] + (s.soft ? SOFT : '') + ']';
        parts.push(v);
        var h = tr(s.soft ? 'soft' : 'hard') + ' ' + tr(s.softPaired ? 'paired' : 'unpaired');
        if (s.softPaired) h += ' [' + s.ch + (s.soft ? '' : SOFT) + ']';
        parts.push(h);
        return parts.join(', ');
    }
    // названия букв — для разбора в 1–4 классе: «л — буква «эль»»
    var LETTER_NAMES = { 'а': 'а', 'б': 'бэ', 'в': 'вэ', 'г': 'гэ', 'д': 'дэ', 'е': 'е', 'ё': 'ё', 'ж': 'жэ', 'з': 'зэ',
        'и': 'и', 'й': 'и краткое', 'к': 'ка', 'л': 'эль', 'м': 'эм', 'н': 'эн', 'о': 'о', 'п': 'пэ', 'р': 'эр', 'с': 'эс',
        'т': 'тэ', 'у': 'у', 'ф': 'эф', 'х': 'ха', 'ц': 'цэ', 'ч': 'че', 'ш': 'ша', 'щ': 'ща', 'ъ': 'твёрдый знак',
        'ы': 'ы', 'ь': 'мягкий знак', 'э': 'э', 'ю': 'ю', 'я': 'я' };
    function letterCell(letter) {
        var td = el('td', 'fon-letter', letter);
        if (grade === 'junior' && LETTER_NAMES[letter]) td.appendChild(el('span', 'fon-lname', '«' + LETTER_NAMES[letter] + '»'));
        return td;
    }

    function table(r) {
        var t = el('table', 'fon-table');
        var hd = el('tr');
        [tr('col_letter'), tr('col_sound'), tr('col_about')].forEach(function (h) { hd.appendChild(el('th', null, h)); });
        var thead = el('thead'); thead.appendChild(hd); t.appendChild(thead);
        var body = el('tbody');
        r.rows.forEach(function (row) {
            if (!row.sounds.length) {
                var tr0 = el('tr');
                tr0.appendChild(letterCell(row.letter));
                tr0.appendChild(el('td', 'fon-sound', '—'));
                tr0.appendChild(el('td', null, tr(row.rule === 'soft_sign' ? 'no_sound_soft' : row.rule === 'hard_sign' ? 'no_sound_hard' : 'no_sound')));
                body.appendChild(tr0);
                return;
            }
            row.sounds.forEach(function (s, i) {
                var r1 = el('tr');
                if (i === 0) {
                    var lt = letterCell(row.letter);
                    if (row.sounds.length > 1) lt.rowSpan = row.sounds.length;
                    r1.appendChild(lt);
                }
                r1.appendChild(el('td', 'fon-sound', '[' + s.sym + ']'));
                r1.appendChild(el('td', null, describe(s)));
                body.appendChild(r1);
            });
        });
        t.appendChild(body);
        return t;
    }

    function scheme(r) {
        var box = el('div', 'fon-scheme');
        box.setAttribute('aria-label', tr('scheme_label'));
        r.rows.forEach(function (row) {
            row.sounds.forEach(function (s) {
                var cls = s.kind === 'vowel' ? 'fon-sq fon-sq-v' : (s.soft ? 'fon-sq fon-sq-s' : 'fon-sq fon-sq-h');
                var sq = el('span', cls);
                if (s.kind === 'vowel' && s.stressed) sq.classList.add('fon-sq-stress');
                sq.title = '[' + s.sym + ']';
                box.appendChild(sq);
            });
        });
        return box;
    }

    // Запись в тетрадь — форма, по которой учителя проверяют ВПР: слоги с ударением,
    // по строке на букву, [–] у ь, ъ и немых согласных, итог «N букв, N звуков»
    function notebookText(r) {
        var syl = r.syllables.length ? r.syllables.map(function (s) {
            return s.stressed && r.vowels > 1 ? s.text.replace(/([аеиоуыэюя])/, '$1' + ACUTE) : s.text;
        }).join('-') : r.word;   // слово без гласных: слогов нет, пишем само слово
        var lines = [syl + ' — ' + plural(r.syllables.length, 'syllable_forms'), r.transcription];
        r.rows.forEach(function (row) {
            if (!row.sounds.length) { lines.push(row.letter + ' — [–]'); return; }
            row.sounds.forEach(function (s, i) {
                lines.push((i === 0 ? row.letter : ' ') + ' — [' + s.sym + '] — ' + describe(s) + ';');
            });
        });
        lines.push(plural(r.letters, 'letter_forms') + ', ' + plural(r.soundsCount, 'sound_forms') + '.');
        return lines.join('\n');
    }

    // класс: 1–4 (цветная схема) или 5–11
    Array.prototype.forEach.call(document.querySelectorAll('[data-fon-grade]'), function (b) {
        b.addEventListener('click', function () {
            grade = b.getAttribute('data-fon-grade');
            try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'grade', grade); } catch (_) {}
            syncGrade();
            if (current) show(current);
        });
    });
    function syncGrade() {
        Array.prototype.forEach.call(document.querySelectorAll('[data-fon-grade]'), function (b) {
            var on = b.getAttribute('data-fon-grade') === grade;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
    }
    syncGrade();

    // ?w=слово — ссылка на разбор (канонический адрес у страницы один)
    try {
        var q = new URLSearchParams(location.search).get('w');
        if (q) { input.value = q; run(q); }
    } catch (_) {}
})();
